import { render, staticRenderFns } from "./registrations-table-row-menu.vue?vue&type=template&id=0ee57ec0"
import script from "./registrations-table-row-menu.vue?vue&type=script&lang=js"
export * from "./registrations-table-row-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports